BinderPrematchFavorites = window.BinderPrematchFavorites = (function () {
    return {
        bind: BinderPrematch.bindFavorites,
        unBind: BinderPrematch.unBind,
        name: 'BinderPrematchFavorites',
        url: '/Prematch/GetFavoritesViewSet'
    };
}());


ScopePrematchFavorites = window.ScopePrematchFavorites = (function () {
    return {
        start: ScopePrematch.start,
        stop: ScopePrematch.stop,
        name: 'ScopePrematchFavorites',
        url: '/PREMATCH/FAVORITES',
        title: Localization.getString('Shared.FavoritePrematch','Линия: Избранное')
    };
}());